import React, { useRef, useEffect, useState } from "react";
import Select from "react-select";

const SelectDropdownLabel = ({
  options,
  selectedOption,
  setSelectedOption,
  name,
  closeSelect,
  isDisable,
  preventKeyboardOpen,
  isShowTop,
  ...props
}) => {
  const [isClient, setIsClient] = useState(false);
  const dateRangeRef = useRef();

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isClient) return;

    const handleClickOutside = (event) => {
      if (
        closeSelect &&
        dateRangeRef.current &&
        !dateRangeRef.current.contains(event.target)
      ) {
        closeSelect();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isClient, closeSelect]);

  return (
    <div
      ref={dateRangeRef}
      style={{ width: "100%", height: "100%", minWidth: "100%" }}
      className={`${isDisable ? "disable" : ""}`}
    >
      {isClient && (
        <Select
          value={selectedOption}
          {...props}
          onChange={setSelectedOption}
          options={options || []}
          placeholder={`${name}`}
          isClearable
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          isDisabled={isDisable}
          isSearchable={preventKeyboardOpen ? false : true}
          menuPlacement={isShowTop ? "top" : "auto"}
        />
      )}
    </div>
  );
};

export default SelectDropdownLabel;
